module.exports = __webpack_public_path__ + "static/nwh-2072814a7bbb84ae08dbe956b7232d35.jpg";